import React from "react";
import { Reveal } from "../shared/Reveal";

const GAP_POINTS = [
  ["No cost, no obligation", "A genuinely complimentary review — no strings, no hard sell."],
  ["Real data from your site", "We measure your building, not guess. Facts, not estimates."],
  ["See your hidden waste", "A clear picture of exactly where energy is being lost — and the savings on offer."],
  ["Knowledge before investment", "A clear roadmap first, so you invest with confidence."],
];

export default function GapAnalysis() {
  return (
    <section id="gap-analysis" className="gapsec arcsec">
      <div className="arc" />
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">YOUR NO-COST FIRST STEP</Reveal>
        <Reveal className="h2" tag="div">Start With a <span className="g">Complimentary Gap Analysis.</span></Reveal>
        <Reveal className="lead" tag="p">It costs nothing to find out. We measure your building with real, live data and show you exactly where energy is being wasted — before a single penny is invested.</Reveal>
        <div className="gapgrid">
          {GAP_POINTS.map(([h, p], i) => (
            <Reveal className="gapcard" tag="div" key={h} style={{ transitionDelay: `${(i % 2) * 0.08}s` }} data-testid={`gap-point-${i}`}>
              <span className="gapcheck">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              </span>
              <div><h4>{h}</h4><p>{p}</p></div>
            </Reveal>
          ))}
        </div>
        <Reveal className="gapcta" tag="div">
          <a href="/gap-analysis" className="btn" data-testid="gap-cta">Book Your Complimentary Gap Analysis</a>
        </Reveal>
      </div>
    </section>
  );
}
